import React from "react";
import shape1 from "../../images/shapes/shape_section_divider_2.svg";
const ContactInfoSection = () => {
  const contactData = [
    {
      icon: "fa-solid fa-envelope",
      title: "Soporte técnico y preguntas generales",
      description: "Para cualquier consulta sobre tu cuenta o el servicio",
      email: "info@crucoin.ai",
    },
    {
      icon: "fa-solid fa-handshake",
      title: "Alianzas, integraciones y business inquiries",
      description: "Para oportunidades de negocio y colaboraciones",
      email: "info@crucoin.ai",
    },
    {
      icon: "fa-solid fa-clock",
      title: "Horario de atención",
      description:
        "📨 Envíanos un correo y te daremos respuesta lo antes posible (horario de atención: lunes-viernes, 9 h – 18 h GMT-6).",
      closing: "¡Hablemos y construyamos juntos el futuro de CruCoin!",
    },
  ];

  return (
    <section
      id="id_ico_contact_section"
      className="ico_contact_section section_space pb-0 section_decoration section_shadow_top"
    >
      <div className="decoration_item shape_divider_1 pb-5">
        <img src={shape1} alt="Shape Divider" />
      </div>
      <div className="container pt-5 pb-5">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <h2 className="heading_text mb-0 pb-5">Contacto</h2>
          <p className="heading_description mb-0">¡Ponte en contacto!</p>
          <p className="heading_description mb-0">
            ¿Necesitas ayuda con tu cuenta o te interesa colaborar con nosotros?
            Nuestro equipo está listo para responderte.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <ul className="ico_features_group unordered_list_block">
              {contactData.map((item, index) => (
                <li
                  key={index}
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div className="ico_iconbox_icon_left">
                    <div className="iconbox_icon">
                      <i className={item.icon}></i>
                    </div>
                    <div className="iconbox_info">
                      <h3 className="iconbox_title">{item.title}</h3>
                      <p className="iconbox_description mb-2">
                        {item.description}
                      </p>
                      {item.email && (
                        <a
                          href={`mailto:${item.email}`}
                          className="contact_email_link"
                        >
                          {item.email}
                        </a>
                      )}
                      {item.closing && (
                        <p className="contact_closing_text">{item.closing}</p>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
